<template>
  <form ref="form" @submit.prevent="handleSubmit">
    <FormInput v-model="value" :placeholder="placeholder" name="keywords" type="text">
      <button class="btn btn-secondary-subtle">
        <SearchIcon class="svg-16 svg-fill-current" />
      </button>
    </FormInput>
  </form>
</template>

<script>
import FormInput from "./FormInput";
import SearchIcon from "../../icons/atalanda/search.svg";

export default {
  name: "FilterProductSearch",
  components: {
    SearchIcon,
    FormInput,
  },
  props: {
    path: {
      type: String,
      required: false,
      default: "",
    },
    initialValue: {
      type: String,
      default: "",
      required: false,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: this.initialValue,
    };
  },
  methods: {
    handleSubmit() {
      let params = new URLSearchParams(window.location.search);
      params.set("keywords", this.value);
      let pathname = this.path ? `${this.path}&` : `${location.pathname}?`;
      window.location.assign(`${pathname}${params.toString()}`);
    },
  },
};
</script>
